import { render } from "./vdp.vue?vue&type=template&id=2c31deb3"
import script from "./vdp.vue?vue&type=script&lang=js"
export * from "./vdp.vue?vue&type=script&lang=js"
script.render = render

export default script